import { toast } from 'react-toastify';
import { TOAST_CONFIG, TOAST_IDS } from '../const';

export const handleErrorToast = (error, customId) => {
  if (error) {
    toast.dismiss();
    toast.error(error, {
      ...TOAST_CONFIG,
      toastId: customId || TOAST_IDS.ERROR,
    });
  }
};

export const handleSuccessToast = (message, customId) => {
  if (message) {
    toast.dismiss();
    toast.success(message, {
      ...TOAST_CONFIG,
      toastId: customId || TOAST_IDS.SUCCESS,
    });
  }
};

export const handleWarningToast = (message, customId) => {
  if (message) {
    toast.dismiss();
    toast.warning(message, {
      ...TOAST_CONFIG,
      toastId: customId || TOAST_IDS.WARNING,
    });
  }
};

export const handleInfoToast = (message, customId) => {
  if (message) {
    toast.dismiss();
    toast.info(message, {
      ...TOAST_CONFIG,
      toastId: customId || TOAST_IDS.INFO,
    });
  }
};

export const getErrMsgFromResp = (err) => {
  console.log('getErrMsgFromResp', err, err.code);
  // if(err.)
  let errmsg = 'Something went wrong!';
  if (err.code == 'ERR_NETWORK') {
    errmsg =
      'Network error: Unable to reach the server. Please check your connection and try again.';
  } else if (err?.response?.data?.message) {
    errmsg = err.response.data.message;
  } else if (err?.status && err?.data) {
    errmsg = err.data.message;
  } else if (err?.errors?.[0]?.message) {
    errmsg = err?.errors?.[0]?.message;
  } else if (err && typeof err === 'object') {
    // GraphQL response envelope: { <operationName>: { status, message, ... } }
    const firstOp = Object.values(err).find(
      (v) => v && typeof v === 'object' && typeof v.message === 'string'
    );
    if (firstOp?.message) {
      errmsg = firstOp.message;
    }
  }
  return errmsg;
};
